export const friendlyFormatIBAN = (iban: string) => iban.replace(/(.{4})/g, '$1 ').trim();

export const normalizeIBAN = (iban: string) => iban.replace(/\s+/g, '').toUpperCase();

// Formats an IBAN as the user types: normalized (no spaces, uppercased) then grouped by 4.
export const formatIBANWhileTyping = (iban: string) => friendlyFormatIBAN(normalizeIBAN(iban));
